import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSmartQuestionaireDetails } from "../../../../services/CommonService";
import { sendSmartQuestionaire } from "../../../../services/CommonService";
import { toast } from "react-toastify";
import "../SmartQuestionaire.css";

function ManageSmartQuestionaireDetail() {
  const { sleeve_uuid } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  const [selectedRecipientIdx, setSelectedRecipientIdx] = useState(0);
  const [selectedFormIdx, setSelectedFormIdx] = useState(0);
  const [selectedGroupIdx, setSelectedGroupIdx] = useState(0);
  const [mobileOpenFormIdx, setMobileOpenFormIdx] = useState(0);
  const [mobileOpenGroupIdxs, setMobileOpenGroupIdxs] = useState({ 0: 0 });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getSmartQuestionaireDetails({ sleeve_uuid })
      .then((res) => {
        setDetail(res.data.data || null);
        setLoading(false);
        setSelectedRecipientIdx(0);
        setSelectedFormIdx(0);
        setSelectedGroupIdx(0);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Failed to fetch details");
        setLoading(false);
      });
  }, [sleeve_uuid]);

  // Helper: Option rendering
  const renderOptions = (available_options, selected, type) => {
    if (!Array.isArray(available_options) || available_options.length === 0) return <span>-</span>;
    return (
      <div className="smartq-options-inline">
        {available_options.map((opt) => (
          <div className="form-check" key={opt.option_id}>
            <input
              className="form-check-input"
              type={type}
              value={opt.name}
              checked={
                type === "checkbox"
                  ? Array.isArray(selected) && selected.includes(opt.name)
                  : selected === opt.name
              }
              readOnly
            />
            <label className="form-check-label">{opt.name}</label>
          </div>
        ))}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>
    );
  }

  if (!detail || !Array.isArray(detail.recipients) || detail.recipients.length === 0) {
    return (
      <div className="container py-4">
        <h4>No details found.</h4>
      </div>
    );
  }

  // Data extraction for selected indexes
  const recipients = detail.recipients;
  const recipient = recipients[selectedRecipientIdx] || recipients[0];
  const forms = recipient?.forms || [];
  const form = forms[selectedFormIdx] || forms[0];
  const groups = form?.groups || [];
  const group = groups[selectedGroupIdx] || groups[0];
  const questions = group?.questions || [];
  // Check if status is in progress
  const isInProgress = detail.status === 2;
  // Check if recipient status is pending
  const isRecipientPending = recipient?.status === 'pending';
  // Helper: Check if all questions in the group are unanswered
  const allQuestionsUnanswered = isInProgress && questions.length > 0 && questions.every(ans => {
    const isAnswered = (
      (Array.isArray(ans.available_options) && ans.available_options.length > 0 &&
        ((Array.isArray(ans.answer_options) && ans.answer_options.length > 0) || ans.answer_option)) ||
      (ans.answer_text !== null && ans.answer_text !== undefined && ans.answer_text !== "")
    );
    return !isAnswered;
  });

  // Sidebar click handlers
  const handleFormClick = (fidx) => {
    setSelectedFormIdx(fidx);
    setSelectedGroupIdx(0); // Reset group selection
  };
  const handleGroupClick = (gidx) => {
    setSelectedGroupIdx(gidx);
  };

  const handleBack = () => {
    navigate("/client-portal/smart-questionnaire/manage");
  }

  const handleRecipientChange = (idx) => {
    setSelectedRecipientIdx(idx);
    setSelectedFormIdx(0);
    setSelectedGroupIdx(0);
  };

  // Resend handler
  const handleResend = () => {
    if (!detail?.sleeve_uuid || !recipient?.recipient_email) return;
    setResendLoading(true);
    sendSmartQuestionaire({ sleeve_uuid: detail.sleeve_uuid, recipient_email: recipient.recipient_email })
      .then((res) => {
        toast.success(res.data.message || 'Resent successfully');
        setResendLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || 'Resend failed');
        setResendLoading(false);
      });
  };
  return (
    <div className="section-bg-color">
      <div style={{ minHeight: "calc(100vh - 54.5px)" }} className="pt-2">
        <div className="container">
          {/* Header */}
          <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap manage-sq-detail">
            <div>
              <h2 className="text-center text-white mb-0 me-3">
                {detail.sleeve_name}
              </h2>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <div>
                <button
                  className="modern-back-btn me-3 d-flex align-items-center bg-black text-white"
                  onClick={handleBack}
                  type="button"
                >
                  <span className="back-arrow">&larr;</span>
                  <span className="back-text">Back</span>
                </button>
              </div>
              <div>
                {recipients.length > 1 && (
                  <div
                    className="dropdown"
                    tabIndex={-1}
                  >
                    <button
                      className="btn btn-light dropdown-toggle d-flex align-items-center"
                      type="button"
                      id="recipientDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded={dropdownOpen}
                      onClick={() => setDropdownOpen((prev) => !prev)}
                    >
                      Select Recipient

                      <span className="ms-2">
                        {/* {recipient.recipient_email} */}
                        {dropdownOpen ? (
                          <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M4.646 10.854a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708 0z" /></svg>
                        ) : (
                          <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" /></svg>
                        )}
                      </span>
                    </button>
                    <ul
                      className={`dropdown-menu${dropdownOpen ? ' show' : ''}`}
                      aria-labelledby="recipientDropdown"
                    >
                      {recipients.map((r, idx) => (
                        <li key={r.recipient_email}>
                          <button
                            className={`dropdown-item${selectedRecipientIdx === idx ? ' active' : ''}`}
                            type="button"
                            onClick={() => { handleRecipientChange(idx); setDropdownOpen(false); }}
                          >
                            {r.recipient_email}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>

          </div>
          {/* Main Layout: Sidebar + Detail */}
          <div className="row" style={{ minHeight: 500 }}>
            {/* Mobile: Single card with sidebar UI + questions/answers */}
            <div className="d-block d-md-none mb-3">
              <div className="mobile-single-card">
                {/* Sidebar UI (recipient, forms, groups) */}
                <div className="sidebar-box mobile-sidebar-box">
                  <div className="sidebar-recipient-name">
                    {recipient.recipient_name}
                  </div>
                  <div className="sidebar-recipient-email">
                    <span className="bi bi-envelope sidebar-email-icon"></span>
                    {recipient.recipient_email}
                  </div>
                  {/* Forms & Groups List */}
                  <div>
                    {forms.map((f, fidx) => (
                      <div key={f.form_id} className="sidebar-form-outer">
                        <div
                          className={`sidebar-form-item ${selectedFormIdx === fidx ? "active" : ""}`}
                          onClick={() => handleFormClick(fidx)}
                        >
                          <span className="sidebar-form-label">
                            <span className="bi bi-ui-checks-grid sidebar-form-icon" />
                            {f.form_name}
                          </span>
                          {/* Arrow icon for open/close */}
                          <span className="sidebar-form-arrow">
                            {selectedFormIdx === fidx ? (
                              <i className="bi bi-chevron-down"></i>
                            ) : (
                              <i className="bi bi-chevron-right"></i>
                            )}
                          </span>
                        </div>
                        {/* Groups under this form */}
                        {selectedFormIdx === fidx && (
                          <div className="sidebar-group-list">
                            {f.groups.map((g, gidx) => {
                              const totalCount = Array.isArray(g.questions) ? g.questions.length : 0;
                              const attemptedCount = Array.isArray(g.questions)
                                ? g.questions.filter(ans => (
                                  (Array.isArray(ans.available_options) && ans.available_options.length > 0 &&
                                    ((Array.isArray(ans.answer_options) && ans.answer_options.length > 0) || ans.answer_option)) ||
                                  (ans.answer_text !== null && ans.answer_text !== undefined && ans.answer_text !== "")
                                )).length
                                : 0;
                              return (
                                <div
                                  key={g.group_id}
                                  className={`sidebar-group-item ${selectedGroupIdx === gidx ? "active" : ""}`}
                                  onClick={() => handleGroupClick(gidx)}
                                >
                                  <span className="bi bi-collection sidebar-group-icon" />
                                  {g.group_name}
                                  <span style={{ fontWeight: 500, marginLeft: 6, color: "#b26ad1" }}>
                                    ({attemptedCount}/{totalCount})
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                {/* Full response: all forms, all groups, all questions as nested accordion */}
                <div className="mobile-questions-card">
                  {Array.isArray(forms) && forms.length > 0 ? (
                    forms.map((f, fidx) => (
                      <div key={f.form_id} className="mb-3 mobile-form-accordion-item">
                        <div
                          className={`mobile-form-accordion-header ${mobileOpenFormIdx === fidx ? "open" : ""}`}
                          onClick={() => setMobileOpenFormIdx(mobileOpenFormIdx === fidx ? -1 : fidx)}
                        >
                          <span className="mobile-form-title mb-0">{f.form_name}</span>
                          <span className="mobile-form-accordion-arrow">
                            {mobileOpenFormIdx === fidx ? (
                              <i className="bi bi-chevron-up"></i>
                            ) : (
                              <i className="bi bi-chevron-down"></i>
                            )}
                          </span>
                        </div>
                        {mobileOpenFormIdx === fidx && (
                          <div className="mobile-form-accordion-body">
                            {Array.isArray(f.groups) && f.groups.length > 0 ? (
                              f.groups.map((g, gidx) => (
                                <div key={g.group_id} className="mb-3 mobile-group-accordion-item">
                                  <div
                                    className={`mobile-group-accordion-header ${mobileOpenGroupIdxs[fidx] === gidx ? "open" : ""}`}
                                    onClick={() => setMobileOpenGroupIdxs((prev) => ({ ...prev, [fidx]: prev[fidx] === gidx ? -1 : gidx }))}
                                  >
                                    <span className="mobile-group-title mb-0">{g.group_name}</span>
                                    <span className="mobile-group-accordion-arrow">
                                      {mobileOpenGroupIdxs[fidx] === gidx ? (
                                        <i className="bi bi-chevron-up"></i>
                                      ) : (
                                        <i className="bi bi-chevron-down"></i>
                                      )}
                                    </span>
                                  </div>
                                  {mobileOpenGroupIdxs[fidx] === gidx && (
                                    <div className="mobile-group-accordion-body">
                                      <div className="mobile-group-answer-card">
                                        <div className="mobile-group-breadcrumb mb-3">
                                          <span className="mobile-group-breadcrumb-form">{f.form_name}</span>
                                          <span className="mobile-group-breadcrumb-sep">&gt;</span>
                                          <span className="mobile-group-breadcrumb-group">{g.group_name}</span>
                                        </div>
                                        {Array.isArray(g.questions) && g.questions.length > 0 ? (
                                          g.questions.map((ans) => {
                                            const isAnswered = (
                                              (Array.isArray(ans.available_options) && ans.available_options.length > 0 &&
                                                ((Array.isArray(ans.answer_options) && ans.answer_options.length > 0) || ans.answer_option)) ||
                                              (ans.answer_text !== null && ans.answer_text !== undefined && ans.answer_text !== "")
                                            );
                                            return (
                                              <div className="mb-4" key={ans.question_id}>
                                                <label className="form-label" style={{ color: "#b26ad1", fontWeight: 600 }}>{ans.question_text}</label>
                                                {(() => {
                                                  if (Array.isArray(ans.available_options) && ans.available_options.length > 0) {
                                                    if (Array.isArray(ans.answer_options) && ans.answer_options.length > 0) {
                                                      return renderOptions(ans.available_options, ans.answer_options, "checkbox");
                                                    } else if (ans.answer_option) {
                                                      return renderOptions(ans.available_options, ans.answer_option, "radio");
                                                    } else if (!isAnswered) {
                                                      return (
                                                        <div className="not-answer-submitted-box d-flex align-items-center my-2">
                                                          <svg width="20" height="20" fill="#dc3545" className="me-2" viewBox="0 0 16 16">
                                                            <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 12.93A5.93 5.93 0 1 1 8 2.07a5.93 5.93 0 0 1 0 11.86z" />
                                                            <path d="M7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm.93-7.481a.5.5 0 0 1 .992 0l.007.39c.058 1.518.07 2.007.07 2.591 0 .584-.012 1.073-.07 2.591l-.007.39a.5.5 0 0 1-.992 0l-.007-.39C7.012 8.073 7 7.584 7 7c0-.584.012-1.073.07-2.591l.007-.39z" />
                                                          </svg>
                                                          <span className="not-answer-text">Not Answer Submitted</span>
                                                        </div>
                                                      );
                                                    } else {
                                                      return renderOptions(ans.available_options, [], "radio");
                                                    }
                                                  }
                                                  if (ans.answer_text !== null && ans.answer_text !== undefined && ans.answer_text !== "") {
                                                    if (ans.question_type === "textarea") {
                                                      return (
                                                        <textarea className="form-control" value={ans.answer_text} readOnly rows={3} />
                                                      );
                                                    } else {
                                                      return (
                                                        <input type="text" className="form-control" value={ans.answer_text} readOnly />
                                                      );
                                                    }
                                                  }
                                                  if (!isAnswered) {
                                                    return (
                                                      <div className="not-answer-submitted-box d-flex align-items-center my-2">
                                                        <svg width="20" height="20" fill="#dc3545" className="me-2" viewBox="0 0 16 16">
                                                          <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 12.93A5.93 5.93 0 1 1 8 2.07a5.93 5.93 0 0 1 0 11.86z" />
                                                          <path d="M7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm.93-7.481a.5.5 0 0 1 .992 0l.007.39c.058 1.518.07 2.007.07 2.591 0 .584-.012 1.073-.07 2.591l-.007.39a.5.5 0 0 1-.992 0l-.007-.39C7.012 8.073 7 7.584 7 7c0-.584.012-1.073.07-2.591l.007-.39z" />
                                                        </svg>
                                                        <span className="not-answer-text">Not Answer Submitted</span>
                                                      </div>
                                                    );
                                                  }
                                                  return null;
                                                })()}
                                              </div>
                                            );
                                          })
                                        ) : (
                                          <div className="text-muted">No questions in this group.</div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ))
                            ) : (
                              <div className="text-muted">No groups in this form.</div>
                            )}
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="text-muted">No forms found.</div>
                  )}
                </div>
              </div>
            </div>
            {/* Sidebar - hide on mobile */}
            <div className="col-md-5 col-lg-4 mb-4 col-xl-3">
              <div className="sidebar-box">
                <div className="sidebar-recipient-name">
                  {recipient.recipient_name}
                </div>
                <div className="sidebar-recipient-email">
                  <span className="bi bi-envelope sidebar-email-icon"></span>
                  {recipient.recipient_email}
                </div>
                {/* <div className="mt-3">
                  <button
                    className="btn btn-outline-primary w-100"
                    onClick={handleResend}
                    disabled={resendLoading}
                  >
                    {resendLoading ? (
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    ) : (
                      <i className="bi bi-arrow-repeat me-2"></i>
                    )}
                    Resend Questionnaire
                  </button>
                </div> */}
                {/* Forms & Groups List */}
                <div>
                  {forms.map((f, fidx) => (
                    <div key={f.form_id} className="sidebar-form-outer">
                      <div
                        className={`sidebar-form-item ${selectedFormIdx === fidx ? "active" : ""}`}
                        onClick={() => handleFormClick(fidx)}
                      >
                        <span className="sidebar-form-label">
                          <span className="bi bi-ui-checks-grid sidebar-form-icon" />
                          {f.form_name}
                        </span>
                        {/* Arrow icon for open/close */}
                        <span className="sidebar-form-arrow">
                          {selectedFormIdx === fidx ? (
                            <i className="bi bi-chevron-down"></i>
                          ) : (
                            <i className="bi bi-chevron-right"></i>
                          )}
                        </span>
                      </div>
                      {/* Groups under this form */}
                      {selectedFormIdx === fidx && (
                        <div className="sidebar-group-list">
                          {f.groups.map((g, gidx) => {
                            const totalCount = Array.isArray(g.questions) ? g.questions.length : 0;
                            const attemptedCount = Array.isArray(g.questions)
                              ? g.questions.filter(ans => (
                                (Array.isArray(ans.available_options) && ans.available_options.length > 0 &&
                                  ((Array.isArray(ans.answer_options) && ans.answer_options.length > 0) || ans.answer_option)) ||
                                (ans.answer_text !== null && ans.answer_text !== undefined && ans.answer_text !== "")
                              )).length
                              : 0;
                            return (
                              <div
                                key={g.group_id}
                                className={`sidebar-group-item ${selectedGroupIdx === gidx ? "active" : ""}`}
                                onClick={() => handleGroupClick(gidx)}
                              >
                                <span className="bi bi-collection sidebar-group-icon" />
                                {g.group_name}
                                <span style={{ fontWeight: 500, marginLeft: 6, color: "#b26ad1" }}>
                                  ({attemptedCount}/{totalCount})
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* Detail Panel */}
            <div className="col-md-7 col-lg-8 col-xl-9">
              <div className="smart-form-box p-4" >
                {/* Show full-width message if recipient status is pending */}
                {isRecipientPending ? (
                  <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 300 }}>
                    <svg width="60" height="60" fill="#b26ad1" viewBox="0 0 24 24" style={{ marginBottom: 16 }}>
                      <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 18.5A8.5 8.5 0 1 1 12 3.5a8.5 8.5 0 0 1 0 17zm-1-6.5h2v2h-2zm0-8h2v6h-2z" />
                    </svg>
                    <h4 style={{ color: '#b26ad1', fontWeight: 600 }}>Form not submitted yet</h4>
                    <p className="text-muted mt-2">This recipient has not submitted the form. Once they submit, their answers will appear here.</p>
                  </div>
                ) : (
                  <>
                    {/* Show Not Answer Submitted only once per group if all questions are unanswered and status is in progress */}
                    {allQuestionsUnanswered && (
                      <div className="not-answer-submitted-box d-flex align-items-center my-2" style={{ marginBottom: 24 }}>
                        <svg width="20" height="20" fill="#dc3545" className="me-2" viewBox="0 0 16 16">
                          <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 12.93A5.93 5.93 0 1 1 8 2.07a5.93 5.93 0 0 1 0 11.86z" />
                          <path d="M7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm.93-7.481a.5.5 0 0 1 .992 0l.007.39c.058 1.518.07 2.007.07 2.591 0 .584-.012 1.073-.07 2.591l-.007.39a.5.5 0 0 1-.992 0l-.007-.39C7.012 8.073 7 7.584 7 7c0-.584.012-1.073.07-2.591l.007-.39z" />
                        </svg>
                        <span className="not-answer-text">Not Answer Submitted</span>
                      </div>
                    )}
                    {/* <div className="smartq-breadcrumb mb-3">
                      <span className="smartq-breadcrumb-form">{form.form_name}</span>
                      <span className="smartq-breadcrumb-sep">&nbsp;&gt;&nbsp;</span>
                      <span className="smartq-breadcrumb-group">{group.group_name}</span>
                    </div> */}
                    {questions.length === 0 ? (
                      <div className="text-muted">No questions in this group.</div>
                    ) : (
                      questions.map((ans) => {
                        const isAnswered = (
                          (Array.isArray(ans.available_options) && ans.available_options.length > 0 &&
                            ((Array.isArray(ans.answer_options) && ans.answer_options.length > 0) || ans.answer_option)) ||
                          (ans.answer_text !== null && ans.answer_text !== undefined && ans.answer_text !== "")
                        );
                        return (
                          <div className="mb-4" key={ans.question_id}>
                            <label className="form-label" style={{ color: "#b26ad1", fontWeight: 600 }}>{ans.question_text}</label>
                            {(() => {
                              if (Array.isArray(ans.available_options) && ans.available_options.length > 0) {
                                if (Array.isArray(ans.answer_options) && ans.answer_options.length > 0) {
                                  return renderOptions(ans.available_options, ans.answer_options, "checkbox");
                                } else if (ans.answer_option) {
                                  return renderOptions(ans.available_options, ans.answer_option, "radio");
                                } else if (!isAnswered && !isInProgress) {
                                  return (
                                    <div className="not-answer-submitted-box d-flex align-items-center my-2">
                                      <svg width="20" height="20" fill="#dc3545" className="me-2" viewBox="0 0 16 16">
                                        <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 12.93A5.93 5.93 0 1 1 8 2.07a5.93 5.93 0 0 1 0 11.86z" />
                                        <path d="M7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm.93-7.481a.5.5 0 0 1 .992 0l.007.39c.058 1.518.07 2.007.07 2.591 0 .584-.012 1.073-.07 2.591l-.007.39a.5.5 0 0 1-.992 0l-.007-.39C7.012 8.073 7 7.584 7 7c0-.584.012-1.073.07-2.591l.007-.39z" />
                                      </svg>
                                      <span className="not-answer-text">Not Answer Submitted</span>
                                    </div>
                                  );
                                } else {
                                  return renderOptions(ans.available_options, [], "radio");
                                }
                              }
                              if (ans.answer_text !== null && ans.answer_text !== undefined && ans.answer_text !== "") {
                                if (ans.question_type === "textarea") {
                                  return (
                                    <textarea className="form-control" value={ans.answer_text} readOnly rows={3} />
                                  );
                                } else {
                                  return (
                                    <input type="text" className="form-control" value={ans.answer_text} readOnly />
                                  );
                                }
                              }
                              if (!isAnswered && !isInProgress) {
                                return (
                                  <div className="not-answer-submitted-box d-flex align-items-center my-2">
                                    <svg width="20" height="20" fill="#dc3545" className="me-2" viewBox="0 0 16 16">
                                      <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 12.93A5.93 5.93 0 1 1 8 2.07a5.93 5.93 0 0 1 0 11.86z" />
                                      <path d="M7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm.93-7.481a.5.5 0 0 1 .992 0l.007.39c.058 1.518.07 2.007.07 2.591 0 .584-.012 1.073-.07 2.591l-.007.39a.5.5 0 0 1-.992 0l-.007-.39C7.012 8.073 7 7.584 7 7c0-.584.012-1.073.07-2.591l.007-.39z" />
                                    </svg>
                                    <span className="not-answer-text">Not Answer Submitted</span>
                                  </div>
                                );
                              }
                              return null;
                            })()}
                          </div>
                        );
                      })
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default ManageSmartQuestionaireDetail; 